import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

/**
 * Cierra sesión de forma fiable: intenta revocar el refresh token (global)
 * y, si falla (red u otro), al menos limpia la sesión local.
 */
export async function signOutApp() {
  const g = await supabase.auth.signOut({ scope: 'global' });
  if (!g.error) return { error: null };
  const l = await supabase.auth.signOut({ scope: 'local' });
  return { error: l.error ?? g.error };
}